// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.split-dropdown {
  display: inline-flex;
  align-items: stretch;
  transition: transform 0.2s ease;
}
.split-dropdown .action-btn {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border: none;
  box-shadow: none;
}
.split-dropdown .dropdown-toggle-split {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.split-dropdown .dropdown-toggle-split:hover {
  filter: brightness(0.9);
}

.dropdown-menu {
  border-radius: 0.5rem;
  padding: 0.5rem 0;
}
.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.dropdown-menu .dropdown-item i {
  font-size: 1.1rem;
  color: #6b7280;
}
.dropdown-menu .dropdown-item:hover {
  background-color: rgba(51, 0, 255, 0.08);
  color: #3300FF;
}
.dropdown-menu .dropdown-item:hover i {
  color: #3300FF;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/table-row-actions/table-row-actions.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,oBAAA;EACA,+BAAA;AACJ;AACI;EACI,0BAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;AACR;AAEI;EACI,4BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEQ;EACI,uBAAA;AAAZ;;AAKA;EACI,qBAAA;EACA,iBAAA;AAFJ;AAII;EACI,oBAAA;EACA,iBAAA;EACA,yBAAA;AAFR;AAIQ;EACI,iBAAA;EACA,cAAA;AAFZ;AAKQ;EACI,wCAAA;EACA,cAAA;AAHZ;AAKY;EACI,cAAA;AAHhB","sourcesContent":[".split-dropdown {\n    display: inline-flex;\n    align-items: stretch;\n    transition: transform 0.2s ease;\n\n    .action-btn {\n        border-start-end-radius: 0;\n        border-end-end-radius: 0;\n        border: none;\n        box-shadow: none;\n    }\n\n    .dropdown-toggle-split {\n        border-start-start-radius: 0;\n        border-end-start-radius: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        &:hover {\n            filter: brightness(0.9);\n        }\n    }\n}\n\n.dropdown-menu {\n    border-radius: 0.5rem;\n    padding: 0.5rem 0;\n    \n    .dropdown-item {\n        padding: 0.5rem 1rem;\n        font-size: 0.9rem;\n        transition: all 0.2s ease;\n        \n        i {\n            font-size: 1.1rem;\n            color: #6b7280;\n        }\n\n        &:hover {\n            background-color: rgba(51, 0, 255, 0.08);\n            color: #3300FF;\n            \n            i {\n                color: #3300FF;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
